import config from '@/config'

export default class SystemConfig{
  static getVersion(): string {
    return config.system.version
  }
}
